
import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { useSalon } from '../contexts/SalonContext';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './CustomerList.css';

interface Customer {
    _id: string;
    name: string;
    phone: string;
    email?: string;
    status: 'new' | 'returning' | 'vip';
    lastVisit?: string;
    totalBookings: number;
}

const CustomerList = () => {
    const { currentBusiness } = useSalon();
    const navigate = useNavigate();
    const { t, language } = useLanguage();
    const [customers, setCustomers] = useState<Customer[]>([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');

    useEffect(() => {
        if (currentBusiness) fetchCustomers();
    }, [currentBusiness]);

    const fetchCustomers = async () => {
        if (!currentBusiness?.id) return;
        setLoading(true);
        try {
            const response = await apiService.getCustomers({
                businessId: currentBusiness.id,
                search: search
            });
            if (response.success) {
                setCustomers(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch customers", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        fetchCustomers();
    };

    return (
        <div className="customer-list-container">
            <div className="header-actions">
                <h2>{t('customers.title')}</h2>
                <form onSubmit={handleSearch} className="search-form">
                    <input
                        type="text"
                        placeholder={t('customers.search2')}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <button type="submit">{t('customers.searchBtn')}</button>
                </form>
            </div>

            {loading ? <div>{t('customers.loading')}</div> : (
                <div className="customers-table">
                    <div className="table-header">
                        <div>{t('customers.table.name')}</div>
                        <div>{t('customers.table.phone')}</div>
                        <div>{t('employees.table.status')}</div>
                        <div>{t('customers.table.lastVisit')}</div>
                        <div>{t('customers.table.bookings')}</div>
                        <div>{t('customers.table.actions')}</div>
                    </div>
                    {customers.map(customer => (
                        <div key={customer._id} className="table-row">
                            <div className="customer-name">{customer.name}</div>
                            <div>{customer.phone}</div>
                            <div><span className={`status-badge ${customer.status}`}>{customer.status}</span></div>
                            <div>{customer.lastVisit ? new Date(customer.lastVisit).toLocaleDateString(language === 'vi' ? 'vi-VN' : 'en-US') : '-'}</div>
                            <div>{customer.totalBookings}</div>
                            <div>
                                <button className="view-btn" onClick={() => navigate(`/customers/${customer._id}`)}>
                                    {t('customers.view')}
                                </button>
                            </div>
                        </div>
                    ))}
                    {customers.length === 0 && <div className="no-data">{t('customers.noData')}</div>}
                </div>
            )}
        </div>
    );
};

export default CustomerList;
